module.exports = __webpack_public_path__ + "static/media/flower-tulip.666aab12.svg";